// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".toast-alert[data-v-3ac33210]{max-width:360px;margin-bottom:10px;cursor:pointer;overflow:hidden;padding-left:16px!important;border-left-width:4px!important}.toast-content[data-v-3ac33210]{pointer-events:none}", ""]);
// Exports
module.exports = exports;
